import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Close, Check as CheckIcon } from '@mui/icons-material';

interface CommonModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  onSave: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const DynamicModal = ({
  open,
  onClose,
  title,
  icon,
  children,
  onSave,
  loading = false,
  disabled = false,
}: CommonModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
        <br />
        {icon && <Box textAlign="center">{icon}</Box>}
        <Typography variant="h4" textAlign="center">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        {children}

        <LoadingButton
          sx={{ mt: 2 }}
          type="submit"
          variant="contained"
          size="small"
          fullWidth
          loading={loading}
          loadingPosition="start"
          color="secondary"
          startIcon={<CheckIcon />}
          onClick={onSave}
          disabled={disabled ? true : false}
        >
          Save
        </LoadingButton>
      </DialogContent>
    </Dialog>
  );
};

export default DynamicModal;
